import React, { FC, useState } from "react";
import editIcon from "assets/icons/edit.svg";

interface MotortabDetailsProps {
  id: "insuredDetails" | "nomineeDetails" | "vehicleDetails";
  formProps: any;
}

export const reviewConstants: any = {
  insuredDetails: [
    {
      title: "Insured Name",
      key: "name"
    },
    {
      title: "Phone",
      key: "phone"
    },
    {
      title: "Email",
      key: "email"
    },
    {
      title: "Address",
      key: "address"
    }
  ],
  nomineeDetails: [
    {
      title: "Nominee Name",
      key: "name"
    },

    {
      title: "Relationship",
      key: "relationWithInsured"
    }
  ],
  vehicleDetails: [
    {
      title: "Registration Number",
      key: "registrationNumber"
    },

    {
      title: "Chassis Number",
      key: "chassisNumber"
    },
    {
      title: "Engine Number",
      key: "engineNumber"
    },
    {
      title: "No Claim Bonus",
      key: "noClaimBonus"
    }
  ]
};

const MotortabDetails: FC<MotortabDetailsProps> = ({ id, formProps }) => {
  const [activeEditSection, setActiveEditSection] = useState("");

  const { values, initialValues, setFieldError, setFieldValue, errors } = formProps;

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    const value = e.target.value;

    if (key === "phone") {
      if (value.trim().length > 11) return;
      else {
        const phoneRegex = /^(0?[6-9]\d{9})$/;
        if (value.trim() === "" || !phoneRegex.test(value)) {
          setFieldError(key, "Invalid phone number");
        } else {
          setFieldError(key, undefined);
        }
      }
    } else if (key === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (value.trim() === "" || !emailRegex.test(value)) {
        setFieldError(key, "Invalid email format");
      } else {
        setFieldError(key, undefined);
      }
    } else if (value.trim() === "") setFieldError(key, "This field is required");
    else setFieldError(key, undefined);

    setFieldValue(`${id}.${key}`, value);
  };

  return (
    <div className="px-0 md:px-10">
      <div className={`border-[1px] border-border-color rounded-[6px] p-5 text-sm font-bold mb-10`}>
        {reviewConstants[id]?.map((obj: any, index: number) => {
          if (!initialValues?.[id]?.[obj.key] && id !== "nomineeDetails") return;
          return (
            <div key={index}>
              <div className="flex justify-between items-center pb-5 px-3 md:px-0">
                <div className="space-y-1 w-full">
                  <div className="flex justify-between w-full mb-1">
                    <p>{obj.title}</p>

                    <div onClick={() => setActiveEditSection(obj.key)} className="border-[1px]  border-border-color rounded-[5px] flex gap-x-2 shadow-editShadow items-center text-xs font-medium px-3 py-1 cursor-pointer min-w-16">
                      <img src={editIcon} alt="Edit" />
                      <p>Edit</p>
                    </div>
                  </div>
                  <p className="font-medium text-sm text-[#000000CC] max-w-[80%]">{initialValues?.[id]?.[obj.key]}</p>
                </div>
              </div>

              <div className={`transition-all duration-300 ease-in-out overflow-hidden ${activeEditSection === obj.key ? "max-h-40 opacity-100" : "max-h-0 opacity-0"} bg-[#F4F5FA80] text-[13px] px-3 md:px-0`}>
                <div className="py-3 space-y-2">
                  <p>{obj.label}</p>
                  <input name={obj.key} onChange={(e) => onChangeHandler(e, obj.key)} value={values?.[id]?.[obj.key]} className="appearance-none border focus:outline-none focus:ring-0 rounded w-full md:w-1/2 py-3 px-2 h-8 text-sm font-semibold bg-white text-gray-700 leading-tight focus:shadow-outline" />
                  {errors[obj.key] && <p className="text-red-500 text-xs mt-1">{errors[obj.key]}</p>}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MotortabDetails;
